import * as actions from './actions';
import update from 'react/lib/update';

export const initState = {
	isFetching: false,
	products: [],
	inCreateMode: {
		active: false,
		isSubmitting: false
	},
	inEditMode: {
		active: false,
		productId: null,
		index: null,
		isSubmitting: false
	},
	confirmDeletion: {
		active: false,
		productId: null,
		index: null,
		isSubmitting: false
	}
}

export default (state = initState, action) => {
	switch (action.type) {
		case actions.SET_REDUCER_STATE:
			return update(state, {
				[action.key]: {
					$set: {...state[action.key], ...action.val}
				}
		});
		case actions.GET_PRODUCTS_REQUEST:
			return update(state, {
				isFetching: {
					$set: true
				}
		});
		case actions.GET_PRODUCTS_REQUEST_SUCCESS:
			return update(state, {
				isFetching: {
					$set: false
				},
				products: {
					$splice: [[state.products.length, 0, ...action.products]]
				}
		});
		case actions.GET_PRODUCTS_REQUEST_FAILLURE:
			return update(state, {
				isFetching: {
					$set: false
				}
		});
		case actions.CREATE_PRODUCT_REQUEST:
			return update(state, {
				inCreateMode: {
					isSubmitting: {
						$set: true
					}
				}
		});
		case actions.CREATE_PRODUCT_SUCCESS:
			return update(state, {
				products: {
					$splice: [[0,0,action.product]]
				},
				inCreateMode: {
					active: {
						$set: false
					},
					isSubmitting: {
						$set: false
					}
				}
		});
		case actions.SEARCH_PRODUCTS_REQUEST:
			return update(state, {
				isFetching: {
					$set: true
				}
		});
		case actions.SEARCH_PRODUCTS_REQUEST_SUCCESS:
			return update(state, {
				products: {
					$set: action.products
				},
				isFetching: {
					$set: false
				}
		});
		case actions.SEARCH_PRODUCTS_REQUEST_FAILURE:
			return update(state, {
				isFetching: {
					$set: false
				}
		});
		case actions.CREATE_PRODUCT_REQUEST_FAILURE:
			return update(state, {
				inCreateMode: {
					isSubmitting: {
						$set: false
					}
				}
		});
		case actions.EDIT_PRODUCT_REQUEST:
			return update(state, {
				inEditMode: {
					isSubmitting: {
						$set: true
					}
				}
		});
		case actions.EDIT_PRODUCT_SUCCESS:
			return update(state, {
				products: {
					[action.index]: {
						$set: action.product
					}
				},
				inEditMode: {
					active: {
						$set: false
					},
					isSubmitting: {
						$set: false
					}
				}
		});
		case actions.EDIT_PRODUCT_REQUEST_FAILURE:
			return update(state, {
				inEditMode: {
					isSubmitting: {
						$set: false
					}
				}
		});
		case actions.DELETE_PRODUCT_REQUEST:
			return update(state, {
				confirmDeletion: {
					isSubmitting: {
						$set: true
					}
				}
			});
		case actions.DELETE_PRODUCT_SUCCESS:
			return update(state, {
				products: {
					$splice: [[action.index,1]]
				},
				confirmDeletion: {
					active: {
						$set: false
					},
					isSubmitting: {
						$set: false
					}
				}
			});
		case actions.DELETE_PRODUCT_REQUEST_FAILURE:
			return update(state, {
				confirmDeletion: {
					active: {
						$set: false
					},
					isSubmitting: {
						$set: false
					}
				}
			});
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/App/Product/reducer.js